export const zeroPad = (num: number, digits: number) =>
  Array(Math.max(digits - String(num).length + 1, 0)).join("0") + num;
